import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  Grid,
  MenuItem,
  Select,
  Tab,
  Tabs,
  Typography,
  Link,
  Alert,
  IconButton,
  Menu,
  FormControlLabel,
  Checkbox,
  Icon,
  Avatar,
  Popover,
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
} from "@mui/material";
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import { useSelector, useDispatch } from "react-redux";
import { styled } from "@mui/material/styles";
import { Link as RouterLink, useNavigate } from 'react-router-dom'
import cssVariables from "../../../../theme/cssVariables";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers';
// libs
import Chart from 'react-apexcharts'
import moment from 'moment';
// components
import MessageDialog from "../../../../components/inbox/MessageDialog";
import AlertDialog from "../../../../components/AlertDialog";
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import WarningDialog from "../../../../components/WarningConfirm";
// assets
import MoreVertIcon from '@mui/icons-material/MoreVert';
import fileBrowser from "../../../../icons/file-browser.svg";
import { ReactComponent as PlusIcon } from "../../../../icons/plus.svg";
import { ReactComponent as ExportIcon } from "../../../../icons/export.svg";
import { ReactComponent as SeeChartIcon } from "../../../../icons/see-chart.svg";
import { ReactComponent as GoalWeightIcon } from "../../../../icons/goal-weight.svg";
import { ReactComponent as StatusGraphIcon } from "../../../../icons/status-graph.svg";
import { ReactComponent as FilterIcon } from "../../../../icons/filter.svg";
import { ReactComponent as EyeIcon } from "../../../../icons/eye.svg";
import { ReactComponent as EditIcon } from "../../../../icons/edit.svg";
import { ReactComponent as DeleteIcon } from "../../../../icons/delete.svg";
import { ReactComponent as NoDataIcon } from "../../../../assets/icons/nodata.svg";
import { ReactComponent as AuditLogDeletion } from "../../../../assets/icons/auditLogDeletion.svg";

// services
import { getEvaluateCycleList, getGoalListV2, deleteGoal, putUpdateProgress, getMyGoalProgress, getGoalAlignmentDetail } from "../../../../actions/corporateGoal";
import * as Util from "../../../../services/global.service";
import ClearIcon from "@mui/icons-material/Clear";
import dayjs from 'dayjs'
import DialogAuditLog from "./DialogAuditLog";

const CategoryNoData = (props) => {
  const { t } = useTranslation();
  let category = props.category
  return (
    <Grid item lg={12} md={12} xs={12}>
      <Card sx={{ height: "450px", display: "flex", justifyContent: "center", flexDirection: "column", boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)!important" }}>
        <Grid container mb={1} display="flex" alignItems="center" justifyContent="center">
          <Grid item>
            <img src={fileBrowser} alt="browser" />
          </Grid>
        </Grid>
        <Grid container mb={1} display="flex" alignItems="center" justifyContent="center">
          <Grid item>
            <Typography color="#939393" fontWeight="400">{t("corporateGoal.label.noData")}</Typography>
          </Grid>
        </Grid>
        {(category && category?.name && category?.id) &&
          <Grid container mb={1} display="flex" alignItems="center" justifyContent="center">
            <Grid item>
              <Typography color="#5DA196" fontWeight="500" sx={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => props.goToCreate(category)}>{t("corporateGoal.label.clickHereToCreate")} {category.name.toLowerCase()}</Typography>
            </Grid>
          </Grid>
        }
      </Card>
    </Grid>
  )
}

const NoData = () => {
  const { t } = useTranslation();
  return (
    <Grid container xs="12" md="12" lg="12" xl="12" display="flex" justifyContent="center" alignItems="center" mt={2}>
      <Grid item display="flex" justifyContent="center" alignItems="center" flexDirection="column">
        <NoDataIcon />
        <Typography fontSize="18px" fontWeight="500" color="#A3A3A3">{t("corporateGoal.label.noData")}</Typography>
      </Grid>
    </Grid>
  )
}

const ManageCorporateGoal = (props) => {
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const corporateGoalState = useSelector((state) => state.CorporateGoal)
  i18n.language === "th-TH" ? moment.locale('th') : moment.locale('en')

  // Variable Start
  const [cycleList, setCycleList] = React.useState([]);
  const [cycleSelectValue, setCycleSelectValue] = React.useState("");
  const handleChangeCycleSelect = (event) => {
    dispatch({
      type: "SET_CORP_GOAL_CURRENT_CYCLE",
      payload: event.target.value
    })
  };
  const [selectedWorkloadType, setWorkloadTypeSelected] = React.useState("all");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const openOption = Boolean(anchorEl);

  const options = [
    t('corporateGoal.label.goalAlignment'),
    t('corporateGoal.label.edit'),
    t('corporateGoal.label.delete')
  ]
  const [alertSummary, showAlertSummary] = React.useState(false);
  const internalSummary = { weight: 60, data: [{ name: 'On-time critical position fulfullment' }] }
  const customerSummary = { weight: 20, data: [{ name: 'On-time critical position fulfullment2' }] }
  const financialSummary = { weight: 20, data: [{ name: 'On-time critical position fulfullment3' }] }
  const [goalProgress, setGoalProgress] = React.useState({
    date: null,
    Graph: {
      data: {
        value: [],
      }
    },
    data_as_of: "",
    more_data: [],
    total_goal: 0,
  })
  const [totalGoalData, setTotalGoalData] = React.useState({
    date: null,
    Graph: {
      data: {
        value: [],
      }
    },
    data_as_of: "",
    more_data: [],
    total_goal: 0,
  })
  const [isApproveDialogOpen, openApproveDialog] = React.useState(false)
  const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false)
  const [isConfirmDeleteDialogOpen, openConfirmDeleteDialog] = React.useState(false)

  const [fullVersion, setFullVersion] = React.useState(true)
  const [emptyObject, setEmptyObject] = React.useState({
    dataLabels: {
      enabled: false
    },
    states: {
      hover: {
        filter: {
          type: 'darken',
          value: 0.9,
        }
      },
    },
    legend: {
      show: false
    },
    colors: ['#F5F5F5'],
    tooltip: {
      enabled: false,
    },
    states: {
      hover: {
        filter: {
          type: 'none',
        }
      },
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              show: true,
            },
            value: {
              show: true,
              fontSize: '12px',
              fontFamily: 'Kanit',
            },
            total: {
              show: true,
              showAlways: true,
              label: '0%',
              fontSize: '14px',
              fontFamily: "Kanit",
              fontWeight: 300,
              color: '#A3A3A3',
              background: "#fff",
              formatter: function (w) {
                return 0
              }
            },
            style: {
              fontFamily: 'Kanit',
            }
          }
        }
      }
    }
  })
  const [emptySeries, setEmptySeries] = React.useState([1])
  const [isAlertDialogOpen, openAlertDialogOpen] = React.useState(false);
  const [title, setTitle] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [color, setColor] = React.useState("");
  const [colorHover, setColorHover] = React.useState("");
  const [size, setSize] = React.useState("");
  const [typeAlertDialog, setTypeAlertDialog] = React.useState("");
  const [errorText, seterrorText] = React.useState("");
  const [approveSummary, setApproveSummary] = React.useState(true);
  const open = Boolean(anchorEl2);
  const id = open ? 'simple-popover' : undefined;
  const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
  const [valueTab, setValueTab] = React.useState("all");
  const [deleteSerial, setDeleteSerial] = React.useState(null);
  const [goalData, setGoalData] = React.useState(null)


  const [chartObject, setChartObject] = React.useState({
    chart: {
      offsetX: 30
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              show: true,
              offsetY: 25,
              formatter: () => t('mygoal.label.complete')
            },
            value: {
              show: true,
              fontSize: '30px',
              fontFamily: "Kanit",
              fontWeight: 600,
              color: undefined,
              offsetY: -15,
              color: '#5DA196',
              formatter: function (val) {
                return val
              }
            },
            total: {
              show: true,
              showAlways: true,
              fontSize: '14px',
              fontFamily: "Kanit",
              fontWeight: 300,
              color: '#A3A3A3',
              background: "#fff",
            }
          }
        }
      }
    },
    states: {
      hover: {
        filter: {
          type: 'darken',
          value: 0.9,
        }
      },
    },
    stroke: {
      width: 0,
      colors: ["#fff"],
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      enabled: true,
      enabledOnSeries: undefined,
      shared: true,
      followCursor: false,
      intersect: false,
      inverseOrder: false,
      custom: undefined,
      fillSeriesColor: false,
      theme: false,
      onDatasetHover: {
        highlightDataSeries: false,
      },
      style: {
        fontSize: '16px',
        fontFamily: "Kanit",
        fontWeight: 300,
      },
      x: {
        show: true,
      },
      y: {
        title: {
          formatter: (seriesName) => seriesName + ":",
        },
        style: {
          fontSize: '16px',
          fontFamily: "Kanit",
          fontWeight: 300,
        },
        formatter: function (val) {
          return val;
        },
      },
      marker: {
        show: true,
      },
      items: {
        display: "flex",
      },
      fixed: {
        enabled: false,
        position: 'topRight',
        offsetX: 0,
        offsetY: 0,
      },
    },
    fill: {
      opacity: 1,
      // type: ['solid', 'gradient'],
      // colors: '#F0F0F0'
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 200
        },
        legend: {
          show: false
        }
      }
    }],
    legend: {
      show: false,
      position: "right",
      offsetY: 0,
      height: 200,
      // horizontalAlign: "left",
      // offsetX: -33,
      // offsetY: -55,
      formatter: function (val, opts) {
        const roundToHundred = (arr) => {
          let output = [];
          let acc = 0;
          for (let i = 0; i < arr.length; i++) {
            let roundedCur = Math.round(arr[i][0]);
            const currentAcc = acc;
            if (acc == 0) {
              output.push(roundedCur);
              acc += arr[i][0];
              continue;
            }
            acc += arr[i][0];
            output.push(Math.round(acc) - Math.round(currentAcc));
          }
          return output;
        };
        let roundedVal = roundToHundred(opts.w.globals.seriesPercent);
        return (
          "<span class='fs-12px ml-2'>" +
          (val ? val : "-") +
          ":</span><span class='fs-12px fw-600 float-right ml-1'>" +
          (opts.w.globals.series[opts.seriesIndex] ? opts.w.globals.series[opts.seriesIndex] : 0) +
          " (" + (roundedVal[opts.seriesIndex] ? roundedVal[opts.seriesIndex] : 0) + "%)" +
          "</span>"
        );
      },
    },
  })
  const [goalList, setGoalList] = React.useState({ goal_list: [], total: 0 })
  const [filterCheckbox, setFilterCheckbox] = React.useState({})
  const [checkbox, setCheckbox] = React.useState([]);
  const [serialDetail, setSerialDetail] = React.useState(null);
  const [goalDetailData, setGoalDetailData] = React.useState(null);
  const [checkboxStatus, setCheckboxStatus] = React.useState("all");
  const [goalProgressMockup, setGoalProgressMockup] = React.useState({})
  const [loadApex, setLoadApex] = React.useState(true)
  const [cycleSerial, setCycle] = React.useState("")
  const [targetCondition, setTargetCondition] = React.useState("")
  const [goalCategoriesChart, setGoalCategoriesChart] = React.useState({
    series: {
      value: [],
      total: 0,
    },
    data: [],
    dataLabels: {
      enabled: false
    },
    stroke: {
      width: 0,
    },
    states: {
      hover: {
        filter: {
          type: 'darken',
          value: 0.9,
        }
      },
    },
    legend: {
      show: false
    },
    tooltip: {
      enabled: true,
      enabledOnSeries: undefined,
      shared: true,
      followCursor: false,
      intersect: false,
      inverseOrder: false,
      custom: undefined,
      fillSeriesColor: false,
      theme: false,
      onDatasetHover: {
        highlightDataSeries: false,
      },
      style: {
        fontSize: '16px',
        fontFamily: "Kanit",
        fontWeight: 300,
      },
      x: {
        show: true,
      },
      y: {
        title: {
          formatter: (seriesName) => seriesName + ":",
        },
        style: {
          fontSize: '16px',
          fontFamily: "Kanit",
          fontWeight: 300,
        },
        formatter: function (val) {
          return val;
        },
      },
      marker: {
        show: true,
      },
      items: {
        display: "flex",
      },
      fixed: {
        enabled: false,
        position: 'topRight',
        offsetX: 0,
        offsetY: 0,
      },
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              show: true,
              offsetY: 25,
              formatter: () => t("corporateGoal.label.totalGoal")
            },
            value: {
              show: true,
              fontSize: '30px',
              fontFamily: "Kanit",
              fontWeight: 600,
              color: undefined,
              offsetY: -15,
              color: '#5DA196',
              formatter: function (val) {
                return val
              }
            },
            total: {
              show: true,
              showAlways: true,
              fontSize: '14px',
              fontFamily: "Kanit",
              fontWeight: 300,
              color: '#A3A3A3',
              background: "#fff",
            }
          }
        }
      }
    }
  })
  const [categoriesWeight, setCategoriesWeight] = React.useState([])

  // Variable End

  // Function Start
  const acceptConsent = (data) => {
    navigate(data, { replace: false });
  }
  const handleChangeTabs = (_, val) => {
    if (val) setWorkloadTypeSelected(val);
    setValueTab(val);
  };
  const handleClick = (event, item) => {
    setSerialDetail(item?.id)
    setGoalDetailData(item)
    setAnchorEl(event.currentTarget);
  };
  const handleClearClick = () => {
    setTargetValue(null)
  }
  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl2(null);
  };
  const handleOption = (option, data = {}) => {

    if (option == t('corporateGoal.label.delete')) {
      openConfirmDeleteDialog(true)
      setDeleteSerial(data.id)
    } else if (option === t('corporateGoal.label.goalAlignment')) {
      goto(`/manage-corporate-goal/${serialDetail}`, { cycleSerial: cycleSerial, data: data })
    } else if (option === t('corporateGoal.label.edit')) {
      Object.assign(data, { goalSerial: data.id, cycleSerial: cycleSerial })
      goto('/manage-corporate-goal/create/edit', data)
    }
    setAnchorEl(null);
  };
  const handleCloseFailedMessageDialog = (value) => {
    setFailedMessageDialog(false);
  };
  const handleConfirmDeleteList = () => {
    openConfirmDeleteDialog(false)
    dispatch(deleteGoal(deleteSerial))
      .then(resp => {
        if (resp?.data?.success) {
          openSuccessDeleteDialog(true)
          loadData(cycleSelectValue);
        }
      })
  };
  const handleConfirmApprove = (val) => {
    openApproveDialog(false);
  }
  const handleConfirmApproveDialog = (val) => {
    openApproveDialog(val);
  }
  const checkApproveData = () => {
    if (internalSummary.weight >= 100 && customerSummary.weight >= 100 && financialSummary.weight >= 100) {
      openApproveDialog(true);
    } else {
      showAlertSummary(true);
    }
  }
  const gotoDetail = (serial) => {
    goto(`/manage-corporate-goal/${serial}`)
  }
  const gotoSeeAll = (item) => {
    goto('/mygoal-list', item)
  }
  const gotoCreateGoal = (data = "") => {
    goto('/manage-corporate-goal/create', { cycleSerial: cycleSerial, category: data });
  }
  const goto = (route, data) => {
    if (data) {
      navigate("/admin" + route, { replace: false, state: data });
    } else {
      navigate("/admin" + route, { replace: false });
    }
  }
  const onCloseAlertDialog = () => {
    setTitle("")
    setMessage("")
    setColor("")
    setTypeAlertDialog("")
    setColorHover("")
    setSize("")
    openAlertDialogOpen(false)
  }
  const handleConfirmDeleteDialog = (val) => {
    openConfirmDeleteDialog(val)
  };
  const handleCheckbox = (data, index = null) => {
    let tmp = [...checkbox]
    let filterCheck = { ...filterCheckbox }
    if (data === "all") {
      if (checkboxStatus === "indeterminate" || checkboxStatus === "none") {
        tmp = tmp.map(item => item = true)
        Object.keys(filterCheck).forEach(key => {
          filterCheck[key] = true;
        });
      } else if (checkboxStatus === "all") {
        tmp = tmp.map(item => item = false)
        Object.keys(filterCheck).forEach(key => {
          filterCheck[key] = false;
        });
      }
    } else {
      tmp[index] = !tmp[index]
      filterCheck[data] = tmp[index]
    }
    setCheckbox(tmp);
    setFilterCheckbox(filterCheck)
  };

  const checkCheckboxStatus = () => {
    let countChecked = 0
    let result = "none"
    checkbox.forEach(item => {
      if (item) countChecked++
    })
    if (countChecked === checkbox.length) {
      result = "all"
    } else if (countChecked > 0 && countChecked < checkbox.length) {
      result = "indeterminate"
    }
    setCheckboxStatus(result);
  }

  const statusBox = (data, isCenter) => {
    if (data == 'new') {
      return (
        <Box style={{ backgroundColor: '#4E79A71A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal has not been approved yet.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#4E79A7" style={{ cursor: 'default' }}>
              {t('label.status.new')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'approved' || data?.name == 'approved') {
      return (
        <Box style={{ backgroundColor: '#5DA1961A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal is approved'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#5DA196" style={{ cursor: 'default' }}>
              {t('label.status.approve')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'pending_delete' || data == 'pending delete' || data?.description === 'pending_delete') {
      return (
        <Box style={{ backgroundColor: '#CC60581A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal is awaiting approval for deletion.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#CC6058" style={{ cursor: 'default' }}>
              {t('label.status.pendingDelete')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'pending' || data?.name == 'pending') {
      return (
        <Box style={{ backgroundColor: '#F280261A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal is waiting for approved.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#F28026" style={{ cursor: 'default' }}>
              {t('label.status.pending')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else if (data == 'update') {
      return (
        <Box style={{ backgroundColor: '#4E79A71A', width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: '0px' }}>
          <BootstrapTooltip
            placement="right"
            arrow
            title={'This goal updates already and has not been approved yet.'}
            style={{ marginLeft: '5px' }}>
            <Typography fontSize={16} lineHeight="21px" fontWeight="500" color="#4E79A7" style={{ cursor: 'default' }}>
              {t('label.status.update')}
            </Typography>
          </BootstrapTooltip>
        </Box>
      )
    } else {
      return (
        <Box style={{ backgroundColor: data?.color?.background, width: '120px', paddingTop: '8px', paddingBottom: '8px', height: '40px', textAlign: 'center', borderRadius: '5px', margin: isCenter ? '0 auto' : 'none', display: "flex", alignItems: "center", justifyContent: "center", border: (data?.name === 'ยังไม่ได้ดำเนินการ' || data?.name === 'Not Started') ? '1px solid #DADADA4A' : `0px` }}>
          <Typography fontSize={16} lineHeight="21px" fontWeight="500" color={data?.color?.font ?? "#DADADA"}>
            {/* {upperFirstWord(data?.name)} */}
            {data?.name == 'in progress' ? t('label.status.inProgress') : data?.name === 'Not Started' ? t('label.status.notStart') : Util.upperFirstWord(data?.name)}
          </Typography>
        </Box>
      )
    }
  }
  // Function End

  useEffect(() => {
    checkCheckboxStatus()
  }, [checkbox])

  useEffect(() => {
    loadCycle()
  }, [])

  const loadCycle = () => {
    dispatch(getEvaluateCycleList('annual')).then((resp) => {
      setCycleList(resp?.cycle)

      /*
      let isDefault = resp?.cycle.find((obj) => obj.is_current)
      if (corporateGoalState.currentCycle === "") {
        if (isDefault) {
          dispatch({
            type: "SET_CORP_GOAL_CURRENT_CYCLE",
            payload: isDefault.id
          })
        } else {
          dispatch({
            type: "SET_CORP_GOAL_CURRENT_CYCLE",
            payload: resp?.cycle?.length > 0 ? resp.cycle[0].id : ""
          })
        }
      }
      */
    })
  }

  useEffect(() => {
    if (cycleSelectValue) loadData(cycleSelectValue)
  }, [cycleSelectValue])

  useEffect(() => {
    setCycleSelectValue(corporateGoalState.currentCycle)
  }, [corporateGoalState.currentCycle])

  const [haveTemplateData, setHaveTemplateData] = React.useState(false)
  const [categoriesTabs, setCategoriesTabs] = React.useState([])

  const loadData = (serial = "") => {
    if (serial) {
      dispatch(getGoalListV2(serial))
        .then(resp => {
          const goalData = resp.data;
          if (goalData?.goal_category_list?.length > 0) {

            setHaveTemplateData(true)
            setGoalData(goalData)
            setData(goalData)
            setLoadApex(false)
          } else {
            setHaveTemplateData(false)
          }
          let goalProgress = {}
          let checkbox = []
          goalData?.progress_list?.forEach(item => {
            goalProgress[item.name] = true
            checkbox.push(true)
          })
          setFilterCheckbox(goalProgress)
          setCheckbox(checkbox)
        })
    }
  }

  const [extraData, setExtraData] = React.useState([])
  const setData = (rawData) => {
    // merge all data 
    console.log('setData', rawData)
    let goalList = {
      my_goal_list: {
        goal_list: [],
        total: 0
      },
    }
    goalList.my_goal_list = rawData.my_goal_list
    setGoalList(goalList.my_goal_list ?? [])
    setGoalProgress(rawData.goal_progress)
    setCycle(cycleSelectValue)
    setExtraData(rawData.extra)
    // goal progress chart

    /*
    var chartColor = [];

    rawData?.goal_progress?.more_data?.map((item) => {
      chartColor.push(JSON.parse(item.color).font)
    })

    var chartObjectData = { ...chartObject }
    chartObjectData.colors = chartColor;
    chartObjectData.labels = rawData.goal_progress.Graph.data.name;
    const datas = {
      value: rawData.goal_progress.Graph.data.value,
      total: rawData.my_goal_list.total,
    }
    const percent = datas.value[datas.value.length - 1] > 0 ? parseFloat(datas.value[datas.value.length - 1] / datas.total) * 100 : 0;
    chartObjectData.plotOptions.pie.donut.labels.total.formatter = (w) => {
      return `${percent > 0 ? parseFloat(percent).toFixed(1) : '0'}%`
    };

    setChartObject(chartObjectData)
    */

    /*
    // total goal categories chart
    var colorGoalCategoriesChart = []

    let goalCategories = rawData.goal_category_evaluate_ratio

    const goalCategoriesChartDataTemp = goalCategories.sort((a, b) => {
      return a.seq - b.seq
    }).map((item) => {
      colorGoalCategoriesChart.push(item.color)
      return {
        seq: item.seq,
        name: item.name,
        color: item.color,
        serial: item.id,
      }
    })

    var goalCategoriesChartData = { ...goalCategoriesChart }
    goalCategoriesChartData.colors = colorGoalCategoriesChart;
    goalCategoriesChartData.labels = goalCategoriesChartDataTemp.map(item => item.name);

    // get  & set categories value
    let tmpGoalList = { ...goalList }
    let goalListValues = tmpGoalList?.my_goal_list?.goal_list ? tmpGoalList.my_goal_list.goal_list.sort((a, b) => {
      return a.seq - b.seq
    }).map((item, key) => {
      goalCategoriesChartDataTemp[key].value = item.total
      return item.total
    }) : [0]

    goalCategoriesChartData.series.value = goalListValues
    goalCategoriesChartData.series.total = goalListValues.reduce((prev, cur) => prev + cur, 0)
    goalCategoriesChartData.data = goalCategoriesChartDataTemp

    goalCategoriesChartData.plotOptions.pie.donut.labels.total.formatter = (w) => {
      return `${goalCategoriesChartData.series.total}`
    };

    // set value to chart 
    setGoalCategoriesChart(goalCategoriesChartData)

    if (goalList?.my_goal_list?.goal_list) {
      goalList.my_goal_list.goal_list.forEach((item) => {
        goalCategoriesChartData.data.forEach((chartItem, indexChart) => {
          if (chartItem.id === item.id) {
            let sum = item.goal_list.reduce((prev, cur) => prev.weight + cur.weight, 0)
            goalCategoriesChartData.data[indexChart].weight = sum
          }
        })
      })
    }
    */

  }

  const [isUpdateDialogOpen, openUpdateDialog] = React.useState(false);
  const [isSuccessUpdateDialogOpen, openSuccessUpdateDialog] = React.useState(false);
  const [targetValue, setTargetValue] = React.useState(null);
  const [progressValue, setProgressValue] = React.useState(null);
  const [asOfDate, setAsOfDate] = React.useState(Util.formatDate(new Date()));
  const [remark, setRemark] = React.useState("");
  const [goalProgressOption, setGoalProgressOption] = React.useState([]);
  const [goalScaleData, setGoalScaleData] = React.useState([]);
  const [goalDetail, setGoalDetail] = React.useState([]);
  const [openDialogAuditLog, setOpenDialogAuditLog] = React.useState(false);


  const setGoalCategoryChart = () => {
    if (goalData?.goal_category_list?.length > 0) {

      const goalCategoriesChartDataTemp = goalData?.goal_category_list.sort((a, b) => {
        return a.seq - b.seq
      }).map((item) => {
        return {
          seq: item.seq,
          name: item.name,
          color: item.color,
          serial: item.id,
        }
      })

      let goalListValues = goalData?.goal_category_list ? goalData?.goal_category_list.sort((a, b) => {
        return a.seq - b.seq
      }).map((item, key) => {
        goalCategoriesChartDataTemp[key].value = item?.goal_list?.length ?? 0
        return item?.goal_list?.length ?? 0
      }) : [0]

      var goalCategoriesChartData = { ...goalCategoriesChart }
      goalCategoriesChartData.colors = goalData?.goal_category_list.map(item => item.color);
      goalCategoriesChartData.labels = goalData?.goal_category_list.map(item => item.name);
      goalCategoriesChartData.series = goalData?.goal_category_list.map(item => item?.goal_list?.length ?? 0);

      goalCategoriesChartData.series.value = goalListValues
      goalCategoriesChartData.series.total = goalListValues.reduce((prev, cur) => prev + cur, 0)
      goalCategoriesChartData.data = goalCategoriesChartDataTemp

      setGoalCategoriesChart(goalCategoriesChartData)



    }
  }

  const setGoalProgressChart = () => {
    if (goalData?.progress_list?.length > 0) {

      const chartObjectDataTemp = goalData?.progress_list.sort((a, b) => {
        return a.seq - b.seq
      }).map((item) => {
        return {
          seq: item.seq,
          name: item.name,
          color: item.color,
          serial: item.id,
        }
      })

      let progressListValues = goalData?.progress_list ? goalData?.progress_list.sort((a, b) => {
        return a.seq - b.seq
      }).map((item, key) => {
        chartObjectDataTemp[key].value = item?.total ?? 0
        return item?.total ?? 0
      }) : [0]

      var chartObjectData = { ...chartObject }
      chartObjectData.colors = goalData?.progress_list.map(item => item.color.font);
      chartObjectData.labels = goalData?.progress_list.map(item => item.name);
      chartObjectData.series = goalData?.progress_list.map(item => item.total);

      chartObjectData.series.value = progressListValues
      chartObjectData.series.total = progressListValues.reduce((prev, cur) => prev + cur, 0)
      chartObjectData.data = chartObjectDataTemp

      setChartObject(chartObjectData)

    }
  }

  const resetUpdateProgress = () => {
    setAsOfDate(Util.formatDate(new Date()))
    setRemark("")
    setTargetValue(null)
  }

  const handleOpenUpdateGoalProgress = (data) => {
    resetUpdateProgress()
    dispatch(getGoalAlignmentDetail(data.id))
      .then(resp => {
        setGoalDetail(resp.data)
        setGoalScaleData(resp.data)
        if ((resp?.data?.goal_progress?.goal_metric?.description === 'Date' || resp?.data?.goal_progress?.goal_metric?.description === 'ทำได้ภายใน End Date') && resp?.data?.goal_progress?.actual_value !== '') {
          let splitDate = resp?.data?.goal_progress?.actual_value?.split("/")
          splitDate = `${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`
          setTargetValue(splitDate || null)
        } else {
          var date = null
          if (resp?.data?.goal_progress?.actual_value === '' && (resp?.data?.goal_progress?.goal_metric?.description === 'Date' || resp?.data?.goal_progress?.goal_metric?.description === 'ทำได้ภายใน End Date')) {
            date = dayjs().format('MM/DD/YYYY')
          } else {
            date = resp?.data?.goal_progress?.actual_value || null
          }
          setTargetValue(date)
        }
        setTargetCondition(resp?.data?.goal_progress?.target_condition ?? "")
        setProgressValue(resp?.data?.goal_progress?.goal_progress_data?.id)
      })

    dispatch(getMyGoalProgress(data.id))
      .then(resp => {
        if (resp.success)
          setGoalProgressOption(resp.data.goal_progress_data)
      })
    openUpdateDialog(true)
  }

  const handleCloseDialog = () => {
    openUpdateDialog(false);
  };

  const updateGoal = () => {
    openUpdateDialog(false);

    const sendData = {
      goal_id: goalDetail?.goal?.serial,
      target_value: targetValue,
      goal_progress_data: progressValue,
      remark: remark,
      date: asOfDate
    }
    dispatch(putUpdateProgress(goalDetail?.serial, sendData))
      .then((resp) => {
        if (resp.success) {
          openSuccessUpdateDialog(true);
          resetUpdateProgress()
          loadData(cycleSelectValue)
        }
      })
  }

  // sum weight of goal list
  const sumWeight = (goalItems) => {
    let sum = 0
    goalItems.forEach(item => {
      sum += parseFloat(item?.form?.weight ?? 0)
    })
    return sum.toFixed(1)
  }

  const getGoalScale = (serial = "", actualValue = "", type = "") => {
    let foundScale = extraData.find(item => item.goal_serial === (serial ?? ""))
    // let actual = data?.actual_value ? data?.actual_value : data?.goal_progress?.actual_value ? data.goal_progress.actual_value : ""
    let actual = actualValue ?? ""
    let result = { valid: false, level: 0 }
    if (foundScale && foundScale?.scale_level?.length > 0) {
      foundScale.scale_level.forEach(scale => {
        if (type?.toLowerCase() === "value") {
          if (parseFloat(actual) >= parseFloat(scale.min) && parseFloat(actual) <= parseFloat(scale.max)) {
            result.level = scale.level
            result.valid = true
            return result
          }
        } else if (type?.toLowerCase() === "date") {
          let actualDate = moment(actual, "DD/MM/YYYY").format('DD/MM/YYYY')
          if (actualDate === "Invalid date" && actual !== "") {
            actualDate = moment(actual, "MM/DD/YYYY").format('DD/MM/YYYY')
            if (actualDate === "Invalid date" && actual !== "") {
              actualDate = moment(actual, "YYYY-MM-DD").format('DD/MM/YYYY')
            }
          }
          let min = moment(scale.min, "DD/MM/YYYY").format('DD/MM/YYYY')
          let max = moment(scale.max, "DD/MM/YYYY").format('DD/MM/YYYY')
          if (actualDate >= min && actualDate <= max) {
            result.level = scale.level
            result.valid = true
            return result
          }
        }
      })
    }
    return result
  }

  const getChildGoal = (serial) => {
    return extraData.filter(item => item.goal_serial === serial)[0]?.child ?? 0
  }

  const getMembers = (serial) => {
    let findGoal = extraData.filter(item => item.goal_serial === serial)
    return findGoal.length > 0 ? findGoal[0].members : []
  }

  const getMembersQty = (serial) => {
    let findGoal = extraData.filter(item => item.goal_serial === serial)
    return findGoal?.members
  }


  // ----------------------------------
  const useStyles = makeStyles({
    clipPath: 'inset(0% 0% -2px 0% round 2px)',
    root: {
      fontSize: "16px",
    },
    plusSvg: {
      "& > path": {
        fill: "#fff",
        stroke: "#fff",
      }
    },
    inactiveSvg: {
      "& > path": {
        fill: "#D0D0D0"
      },
      '& g > path': {
        fill: '#D0D0D0'
      },
    },
    statusGraph: {
      "& > path": {
        fill: "#fff"
      }
    },
    internalIcon: {
      "& > path": {
        fill: "#fff"
      },
      '& g > path': {
        fill: '#fff'
      },
    },
    linkIcon: {
      "& > path": {
        fill: "#A0A0A0"
      },
      '& g > path': {
        fill: '#A0A0A0'
      },
    },
    paginationRoot: {
      color: `${cssVariables.color.primary}`,
      backgroundColor: "white!important",
      minWidth: "30px!important",
      padding: "5px!important",
    },
    paginationSelected: {
      color: "white!important",
      border: "1px solid rgba(93, 161, 150, 0.5)!important",
      backgroundColor: `${cssVariables.color.primary}!important`,
      minWidth: "30px!important",
      padding: "5px!important",
    },
    clickable: {
      cursor: "pointer",
      transition: "color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      '&:hover': {
        color: 'rgb(65, 112, 105) !important'
      }
    },
    fillDisable: {
      '& > path': {
        fill: '#A0A0A0'
      },
      '& g > path': {
        fill: '#A0A0A0'
      },
    },
    btn: {
      '& > svg': {
        marginLeft: "10px"
      },
    },
  });
  const classes = useStyles();
  const styles = {
    link: {
      color: "#5DA196",
      cursor: "pointer",
    },
    end: {
      color: "#A3A3A3",
    },
  };

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: "#343A40",
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#343A40",
      color: "#FFFFFF",
      padding: "11px 15px",
    },
  }));

  const targetValueFormat = (list) => {
    if (list.goal_metric.description == 'Date') {
      return (
        <Typography fontSize={18} lineHeight="21px" fontWeight="400">
          {Util.upperFirstWord(list?.target_condition ?? '')} {`${list?.target_value ? `${list.target_value} ${list?.metric_unit?.description || ''}` : '-'}`}
        </Typography>
      )
    } else {
      return (
        <Typography fontSize={18} lineHeight="21px" fontWeight="400">
          {Util.upperFirstWord(list?.target_condition ?? '')} {`${list?.target_value ? `${list.target_value} ${list?.metric_unit?.description || ''}` : '-'}`}
        </Typography>
      )
    }
  }

  const reformatDate = (date, sign) => {
    if (date && sign) {
      let formatDate = date.split(sign)
      if (formatDate.length > 2)
        formatDate = `${formatDate[0]}/${formatDate[1]}/${formatDate[2]}`
      return formatDate
    } else {
      return date
    }
  }




  useEffect(() => {
    if (goalData?.goal_category_list?.length > 0) {

      setGoalCategoryChart()
      setGoalProgressChart()
    }
  }, [goalData])

  useEffect(() => {
    if (cycleList.length > 0) {
      setCycleSelectValue(cycleList[0].serial)
    }
  }, [cycleList])

  useEffect(() => {
    console.log('filterCheckbox', filterCheckbox)
  }, [filterCheckbox])

  useEffect(() => {
    if (goalDetailData?.id && anchorEl) {

    }
  }, [goalDetailData, anchorEl])


  return (
    <>
      <Helmet>
        <title>Manage Corporate Goal | KPI </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minheight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.link} onClick={() => acceptConsent('/kpi/home')}>
                {t('label.home')}
              </span> /
              <span style={styles.end} >
                {` ${t('corporateGoal.label.title')}`}
              </span>
            </Typography>
          </Grid>
          <Grid container direction="row">
            <Grid item >
              <Typography color="#404349" fontSize={36} lineHeight="39.6px" fontWeight="600">
                {t("corporateGoal.label.title")}
              </Typography>
            </Grid>
          </Grid>
          <Grid container item my={3}>
            <Grid item md={6} pr={1}>
              <Select
                id="workload-select"
                inputlabelprops={{ shrink: false }}
                variant="outlined"
                size="small"
                className="white-bg"
                value={cycleSelectValue}
                onChange={handleChangeCycleSelect}
                sx={{ width: "400px" }}
              >
                {
                  cycleList?.length > 0 ?
                    cycleList.map((item) => {
                      return (
                        <MenuItem value={item.serial} key={item.serial}>
                          {item.name}
                        </MenuItem>
                      )
                    })

                    : <MenuItem value="">
                      {t("corporateGoal.label.notFound")}
                    </MenuItem>
                }
              </Select>
            </Grid>
            {false &&
              <Grid
                item
                md={6}
                display="flex"
                alignItems="flex-end"
                flexDirection="row-reverse"
              >
                <Box style={{ marginLeft: 10 }}>
                  <Button
                    size="small"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={() => { }}
                    color="black"
                    variant="outlined"
                    style={{ textTransform: 'none' }}
                    disabled={true}
                  >
                    {/* <img src={SeeChartIcon} style={{width: 15, height: 15}} /> */}
                    <SeeChartIcon width={15} height={15} className={fullVersion ? {} : classes.inactiveSvg} />
                    <Typography ml={1} fontSize="16" fontWeight="500">{t("corporateGoal.label.viewChart")}</Typography>
                  </Button>
                </Box>
                <Box>
                  <Button
                    size="small"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={() => { }}
                    color="black"
                    variant="outlined"
                    style={{ textTransform: 'none' }}
                    disabled={true}
                  >
                    {/* <img src={ExportIcon} style={{width: 15, height: 15}} /> */}
                    <ExportIcon width={15} height={15} className={fullVersion ? {} : classes.inactiveSvg} />
                    <Typography ml={1} fontSize="16" fontWeight="500">{t("corporateGoal.label.exportReport")}</Typography>
                  </Button>
                </Box>
              </Grid>
            }
          </Grid>
          {haveTemplateData &&
            <>
              <Grid container spacing={4}>
                <Grid lg={6} xs={12} item>
                  <Card style={{ height: '100%' }} sx={{ boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)!important" }}>
                    <CardContent>
                      <Grid item lg={12} xs={12} container>
                        <Grid
                          item
                          lg={6}
                          xs={12}
                          display="flex"
                          alignItems="center"
                          textAlign="left"
                        >
                          <Grid item style={{ padding: '10px', marginRight: 10, backgroundColor: "#5DA196", width: '40px', height: '40px', borderRadius: 5 }}>
                            <StatusGraphIcon style={{ width: 20, height: 20 }} className={classes.statusGraph} />
                          </Grid>
                          <Grid item>
                            <Typography fontSize={20} lineHeight="21px" fontWeight="600" color="#404349">
                              {t("corporateGoal.label.goalProgress")}
                            </Typography>
                            <Typography fontWeight="300" fontSize={14} color="#939393">
                              {t("corporateGoal.label.dateAsOf")}:{` ${goalData?.info?.data_as_of ?? '-'}`}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                      <Grid container lg={12} xs={12} mb={3}>
                        <Grid lg={6} xs={6} display="flex" justifyContent="start">
                          <Typography fontWeight="600" fontSize={18} color="#404349">
                            {t("corporateGoal.label.goalsStatus")}
                          </Typography>
                        </Grid>
                        <Grid lg={6} xs={6} display="flex" justifyContent="flex-start" alignItems="center">
                          <Typography fontWeight="400" fontSize={14} variant="label">
                            {t("corporateGoal.label.totalGoal")} : {goalData?.info?.total_goal ?? 0} {t("corporateGoal.label.goalUnit")}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container lg={12} xs={12}>
                        <Grid item lg={6} xs={12}>
                          <Box sx={{ "margin-left": "-10px", ".apexcharts-tooltip-y-group > span": { "font-weight": "400" }, ".apexcharts-active": { background: "#F7F7F7", "padding-bottom": "0px", "box-shadow": "0px 2px 4px rgba(0, 0, 0, 0.15)", ".apexcharts-tooltip-marker": { "border-radius": "unset", "border-radius": "2px" } }, ".apexcharts-graphical": { transform: "unset" } }}>
                            {loadApex == false &&
                              (chartObject?.data?.some((item) => item.value !== '0')
                                ?
                                <Chart options={chartObject} series={chartObject?.series?.value} type="donut" />
                                :
                                <Chart options={emptyObject} series={emptySeries} type="donut" />
                              )
                            }
                          </Box>
                        </Grid>
                        <Grid container lg={3} xs={12} direction="row" style={{ display: 'grid' }}>
                          {
                            goalData?.progress_list?.map((item, key) => {
                              if (key < 3) {
                                return (
                                  <Grid key={key} item lg={12} xs={6} sx={{ border: `0.5px solid #DADADA`, borderLeftColor: `${item.color.font}`, borderLeftWidth: 7, borderRadius: 2, padding: '8px 15px 8px 15px', maxHeight: '55px', color: item.color.font }}>
                                    <Grid container direction="row">
                                      <Grid lg={8} xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                                        <Typography fontSize={12} color="#888888" fontWeight="400">
                                          {item.name}
                                        </Typography>
                                      </Grid>
                                      <Grid lg={4} xs={12} style={{ textAlign: 'right' }}>
                                        <Typography fontWeight="bold" fontSize={24} variant="label" color="#404349">
                                          {item.total}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                )
                              }
                            })
                          }
                        </Grid>
                        {goalData?.progress_list?.length > 3 &&
                          <Grid container lg={3} xs={12} direction="row" style={{ display: 'grid' }} pl={1}>
                            {
                              goalData?.progress_list.map((item, key) => {
                                if (key >= 3) {
                                  return (
                                    <Grid key={key} item lg={12} xs={6} sx={{ border: `0.5px solid #DADADA`, borderLeftColor: `${item.color.font}`, borderLeftWidth: 7, borderRadius: 2, padding: '8px 15px 8px 15px', maxHeight: '55px', color: item.color.font }}>
                                      <Grid container direction="row">
                                        <Grid lg={8} xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
                                          <Typography fontSize={12} color="#888888" fontWeight={400}>
                                            {item.name}
                                          </Typography>
                                        </Grid>
                                        <Grid lg={4} xs={12} sx={{ textAlign: 'right', alignItems: 'center' }}>
                                          <Typography fontWeight="bold" fontSize={24} variant="label" color="#404349">
                                            {item.total}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  )
                                }
                              })
                            }
                          </Grid>
                        }
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid lg={6} xs={12} item>
                  <Card style={{ height: '100%' }} sx={{ boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)!important" }}>
                    <CardContent>
                      <Grid item lg={12} xs={12} container>
                        <Grid
                          item
                          lg={6}
                          xs={12}
                          display="flex"
                          alignItems="center"
                          textAlign="left"
                        >
                          <Grid item style={{ padding: '10px', marginRight: 10, backgroundColor: "#5DA196", width: '40px', height: '40px', borderRadius: 5 }}>
                            <StatusGraphIcon style={{ width: 20, height: 20 }} className={classes.statusGraph} />
                          </Grid>
                          <Grid item>
                            <Typography fontSize={20} lineHeight="21px" fontWeight="600" color="#404349">
                              {t("corporateGoal.label.totalGoal")}
                            </Typography>
                            <Typography fontWeight="300" fontSize={14} color="#939393">
                              {t("corporateGoal.label.dateAsOf")}:{` ${goalData?.info?.data_as_of ?? '-'}`}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                      <Grid container lg={12} xs={12} mb={3}>
                        <Grid lg={12} xs={12} display="flex" justifyContent="start">
                          <Typography fontWeight="600" fontSize={18} color="#404349">
                            {t("corporateGoal.label.goalsCategory")}
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container xs={12}>
                        <Grid item xs={6}>
                          <Box sx={{ "margin-left": "-10px", ".apexcharts-tooltip-y-group > span": { "font-weight": "400" }, ".apexcharts-active": { background: "#F7F7F7", "padding-bottom": "0px", "box-shadow": "0px 2px 4px rgba(0, 0, 0, 0.15)", ".apexcharts-tooltip-marker": { "border-radius": "unset", "border-radius": "2px" } }, ".apexcharts-graphical": { transform: "unset" } }}>
                            {loadApex == false &&
                              (goalCategoriesChart?.data?.some((item) => item.value !== '0')
                                ?
                                <Chart options={goalCategoriesChart} series={goalCategoriesChart?.series?.value} type="donut" />
                                :
                                <Chart options={emptyObject} series={emptySeries} type="donut" />
                              )
                            }
                          </Box>
                        </Grid>
                        <Grid container item xs={6} spacing={1} sx={{ maxHeight: "310px", overflowY: "auto" }}>
                          {goalCategoriesChart?.data?.map((item, key) => {
                            // if (key < 10) {
                            return (
                              <Grid key={key} item xs={6}>
                                <Box sx={{ border: `0.5px solid #DADADA`, borderLeftColor: `${item.color}`, borderLeftWidth: 7, borderRadius: 2, padding: '8px 15px 8px 15px', maxHeight: '55px', color: item.color }}>
                                  <Grid container direction="row">
                                    <Grid lg={8} xs={12} sx={{ display: 'flex', overflow: "hidden", maxHeight: "35px" }}>
                                      <Typography fontSize={12} color="#888888" fontWeight={400}>
                                        {item.name ?? "-"}
                                      </Typography>
                                    </Grid>
                                    <Grid lg={4} xs={12} sx={{ textAlign: 'right', display: "flex" }}>
                                      <Typography fontWeight="bold" fontSize={24} color="#404349">
                                        {item.value ?? 0}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Box>
                              </Grid>
                            )
                            // }
                            // return <></>
                          })}
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
              <Grid container mt={5}>
                <Grid
                  item
                  lg={6}
                  xs={12}
                  display="flex"
                  alignItems="center"
                  textAlign="left"
                >
                  <Grid item style={{ padding: 12, marginRight: 10, backgroundColor: "#5DA196", borderRadius: 5 }}>
                    <GoalWeightIcon style={{ width: 24, height: 20 }} className={classes.statusGraph} />
                  </Grid>
                  <Grid item display="flex" alignItems="center">
                    <Typography fontSize={28} fontWeight="600" color="#404349">
                      {t("corporateGoal.label.corporateGoalLists")}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={6}
                  md={12}
                  justifyContent="flex-end"
                  alignItems="flex-end"
                  display="flex"
                >
                  <Button
                    size="small"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={handleClick2}
                    color="black"
                    variant="outlined"
                    sx={{ marginRight: '15px' }}
                    aria-describedby={id}
                    style={{ textTransform: 'none' }}
                  >
                    <FilterIcon style={{ width: '20px', height: '20px' }} />
                    <Typography ml={1} fontWeight="600" fontSize="16px">{t("corporateGoal.label.filters")}</Typography>
                  </Button>
                  <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl2}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                  >
                    {filterCheckbox ?
                      (<Box
                        sx={{
                          p: 1,
                        }}>
                        <Box
                          style={{ "padding-left": "14px", "padding-right": "4px" }}
                          sx={{
                            display: "flex",
                            alignItems: "center"
                          }}>
                          <FormControlLabel
                            style={{ fontSize: '14px' }}
                            label={t("label.selectAll")}
                            control={
                              <Checkbox
                                checked={checkboxStatus === 'all'}
                                indeterminate={checkboxStatus === 'indeterminate'}
                                onChange={() => handleCheckbox("all")}
                                xs={{ pl: 0 }}
                              />
                            }
                          />
                        </Box>
                        {
                          Object.keys(filterCheckbox).map((item, index) => {
                            return (
                              <Box
                                style={{ "padding-left": "12px", "padding-right": "4px" }}
                                sx={{
                                  display: "flex",
                                  alignItems: "center"
                                }}>
                                <FormControlLabel
                                  sx={{ ml: "0!important" }}
                                  style={{ fontSize: '14px' }}
                                  label={item}
                                  control={<Checkbox color="primary" sx={{ pl: 0 }} checked={checkbox[index]} onChange={() => handleCheckbox(item, index)} />}
                                />
                              </Box>
                            )
                          })
                        }
                      </Box>) : null
                    }
                  </Popover>
                  <Button
                    size="small"
                    aria-controls="simple-menu"
                    aria-haspopup="true"
                    onClick={() => { gotoCreateGoal() }}
                    color="primary"
                    variant="contained"
                    style={{ textTransform: 'none' }}
                    disabled={!fullVersion}
                    sx={{ ml: "15px" }}
                  >
                    <PlusIcon className={classes.plusSvg} />
                    <Typography ml={1} style={{ color: '#FFF' }}>{t("corporateGoal.label.createGoal")}</Typography>
                  </Button>
                </Grid>
                <Box pt="10px" sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                  <Box sx={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={e => setOpenDialogAuditLog(true)}>
                    <AuditLogDeletion /> <Typography pl="8px" fontWeight={400} fontSize="14px" color="#6B6B6B">{t('mygoal.label.auditLogDel')}</Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid container pt={'16px'}>
                <Grid item lg={12} md={12} style={{ paddingBottom: '30px' }}>
                  <Tabs
                    value={valueTab}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={handleChangeTabs}
                    aria-label="Tabs"
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    TabIndicatorProps={{
                      style: {
                        height: "8px",
                        fontSize: "20px",
                      },
                    }}
                    style={{ borderBottom: '1px solid #DADADA' }}
                  >
                    <Tab sx={{ fontWeight: "400" }} label={<span className={classes.root} style={{ textTransform: 'none', color: valueTab !== "all" ? "#404349" : "#5DA196" }}>{t("corporateGoal.label.all")}</span>} value="all" />
                    {
                      goalData?.goal_category_list?.map((item, key) => {
                        return (
                          <Tab key={key} sx={{ fontWeight: "400" }} label={<span className={classes.root} style={{ textTransform: 'none', color: valueTab !== item.id ? "#404349" : "#5DA196" }}>{item.name}</span>} value={item.id} />
                        )
                      })
                    }
                  </Tabs>
                </Grid>
              </Grid>
            </>
          }
          {
            haveTemplateData ?
              goalData?.goal_category_list?.length > 0 ?
                goalData?.goal_category_list?.map((item, key) => {
                  if (valueTab === item.id || valueTab === "all") {
                    return (
                      <Grid container key={key} style={{ marginBottom: '40px' }} mt={2}>
                        <Grid item lg={12} md={12}>
                          <Grid container item lg={12} md={12}>
                            <Box sx={{ backgroundColor: `${item.color}`, padding: '15px', borderRadius: '5px', margin: '0 auto', width: "100%" }}>
                              <Grid container>
                                <Grid lg={11} md={12} item sx={{ display: 'flex', alignItems: 'center' }}>
                                  <Icon style={{ color: '#FFFFFF', fontSize: 30 }}>{item.icon}</Icon>
                                  {/* <InternalProcessIcon className={classes.internalIcon} /> */}
                                  <Typography ml={2} fontWeight={600} fontSize={24} style={{ color: "white" }}>
                                    {item.name}
                                  </Typography>
                                </Grid>
                                <Grid lg={1} md={12} item xs={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }} style={{ display: 'none' }}>
                                  <Box style={{ border: '1px solid white', marginLeft: '40px', borderRadius: '5px', margin: '0 auto' }}>
                                    <Typography fontWeight={600} fontSize={24} style={{ color: "white", textAlign: 'center' }}>
                                      {sumWeight(item.goal_list)}%
                                    </Typography>
                                  </Box>
                                </Grid>
                              </Grid>
                            </Box>
                          </Grid>
                          <Grid container direction="row" style={{ justifyContent: 'space-between', marginTop: '20px', marginBottom: '20px' }}>
                            <Grid item lg={11}>
                              <Grid container direction="row">
                                <Grid item>
                                  <Typography fontSize={14} fontWeight="300" variant="label" >
                                    {item.name} :&nbsp;
                                  </Typography>
                                </Grid>
                                <Grid item>
                                  <Typography fontSize={14} fontWeight="300" variant="label" color="primary" >
                                    {item.goal_list.filter((item) => filterCheckbox[item?.form?.progress?.name] ? item : undefined).length}
                                  </Typography>
                                </Grid>
                                <Grid item>
                                  <Typography fontSize={14} fontWeight="300" variant="label" >
                                    &nbsp;{t("corporateGoal.label.goalUnit")}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid container direction="row" spacing={2}>
                            {
                              item?.goal_list?.length > 0
                                ?
                                item.goal_list.filter((item) => filterCheckbox[item?.form?.progress?.name] ? item : undefined).map((list, key) => {
                                  return (
                                    <Grid item lg={6} xs={12} key={key} >
                                      <Card sx={{ boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)!important", minHeight: "410px", height: "100%" }}>
                                        <CardContent sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
                                          <Grid item lg={12} xs={12} container sx={{ flexBasis: "0!important" }}>
                                            <Grid
                                              item
                                              lg={8}
                                              xs={12}
                                              display="flex"
                                              alignItems="center"
                                              textAlign="left"
                                            >
                                              <Grid item direction="column" sx={{ overflow: "hidden" }}>
                                                <BootstrapTooltip
                                                  placement="right"
                                                  arrow
                                                  title={list.name}
                                                  style={{ marginLeft: '5px' }}
                                                >
                                                  <Typography fontSize={20} lineHeight="21px" fontWeight="500" onClick={() => { gotoDetail(list.id) }} sx={{ "&:hover": { cursor: "pointer" }, textOverflow: "ellipsis", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}>
                                                    {list.name}
                                                  </Typography>
                                                </BootstrapTooltip>
                                              </Grid>
                                            </Grid>
                                            <Grid
                                              item
                                              lg={4}
                                              xs={12}
                                              display="flex"
                                              alignItems="right"
                                              justifyContent="right"
                                              style={{ justifyContent: 'flex-end' }}
                                            >
                                              {statusBox(list?.form?.progress ?? goalProgressMockup)}

                                              <IconButton
                                                aria-label="more"
                                                id="long-button"
                                                aria-controls={openOption ? 'long-menu' : undefined}
                                                aria-expanded={openOption ? 'true' : undefined}
                                                aria-haspopup="true"
                                                onClick={(e) => handleClick(e, list)}
                                                sx={{
                                                  borderRadius: '5px', border: '1px solid #E5E5E5', ml: 1, paddingLeft: '1px', paddingRight: '1px', paddingTop: '6px', paddingBottom: '6px',
                                                  "&:hover": {
                                                    backgroundColor: "#EFF6F4"
                                                  }
                                                }}
                                              >
                                                <MoreVertIcon />
                                                {/* style={{border: '1px solid #DADADA'}} */}
                                              </IconButton>


                                            </Grid>
                                          </Grid>
                                          <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                                          <Grid container lg={12} xs={12} mt={3}>
                                            <Grid item lg={4} xs={12} mb={2}>
                                              <Typography fontSize={18} lineHeight="21px" variant="label">
                                                {t("corporateGoal.label.goalWeight")}
                                              </Typography>
                                            </Grid>
                                            <Grid item lg={8} xs={12} mb={2}>
                                              <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                                                {list?.form?.weight} %
                                              </Typography>
                                            </Grid>
                                            <Grid item lg={4} xs={12} mb={2}>
                                              <Typography fontSize={18} lineHeight="21px" variant="label">
                                                {t("corporateGoal.label.goalMetric")}
                                              </Typography>
                                            </Grid>
                                            <Grid item lg={8} xs={12} mb={2}>
                                              <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                                                {list.goal_metric.description}
                                              </Typography>
                                            </Grid>
                                            <Grid lg={4} xs={12} mb={2}>
                                              <Typography fontSize={18} lineHeight="21px" variant="label">
                                                {t("corporateGoal.label.goalType")}
                                              </Typography>
                                            </Grid>
                                            <Grid item lg={8} xs={12} mb={2}>
                                              <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                                                {list.goal_type.description}
                                              </Typography>
                                            </Grid>
                                            <Grid item lg={4} xs={12} mb={2}>
                                              <Typography fontSize={18} lineHeight="21px" variant="label">
                                                {t("corporateGoal.label.startEndDate")}
                                              </Typography>
                                            </Grid>
                                            <Grid item lg={8} xs={12} mb={2}>
                                              <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                                                {
                                                  `${reformatDate(list.start_at, "/")} - ${reformatDate(list.end_at, "/")}`
                                                }
                                              </Typography>
                                            </Grid>
                                            <Grid item lg={4} xs={12} mb={2}>
                                              <Typography fontSize={18} lineHeight="21px" variant="label">
                                                {t("mygoal.label.measurement")}
                                              </Typography>
                                            </Grid>
                                            <Grid item lg={8} xs={12} mb={2}>
                                              <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                                                {list.measurement || '-'}
                                              </Typography>
                                            </Grid>
                                            <Grid item lg={4} xs={12} mb={2}>
                                              <Typography fontSize={18} lineHeight="21px" variant="label">
                                                {t("corporateGoal.label.targetValue")}
                                              </Typography>
                                            </Grid>
                                            <Grid item lg={8} xs={12} mb={2}>
                                              {targetValueFormat(list)}
                                            </Grid>
                                            <Grid item lg={4} xs={12} mb={2}>
                                              <Typography fontSize={18} lineHeight="21px" variant="label">
                                                {t("corporateGoal.label.actualValue")} :
                                              </Typography>
                                            </Grid>
                                            <Grid item lg={5} xs={12} mb={2}>
                                              <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                                                {`${list?.form?.actual_value ? `${list?.form?.actual_value} ${list?.metric_unit?.description || ''}` : '-'}`}
                                              </Typography>
                                            </Grid>
                                            {
                                              (getGoalScale(list?.id, list?.form?.actual_value, list?.metric_unit?.description)?.valid && list?.form?.actual_value) &&
                                              <Grid lg={3} xs={12} mb={2}>
                                                <Typography fontSize={14} lineHeight="21px" fontWeight="500" color="#4085C9" textAlign="right" sx={{ textTransform: "uppercase" }}>
                                                  {t("corporateGoal.label.scaleLevel")} : {getGoalScale(list?.id, list?.form?.actual_value, list?.metric?.description)?.level}
                                                </Typography>
                                              </Grid>
                                            }
                                            <Grid item lg={4} xs={12} mb={2}>
                                              <Typography fontSize={18} lineHeight="21px" variant="label">
                                                {t("corporateGoal.label.childGoal")} :
                                              </Typography>
                                            </Grid>
                                            <Grid item lg={5} xs={12} mb={2}>
                                              <Typography fontSize={18} lineHeight="21px" fontWeight="400">
                                                {list?.total_child ?? 0}
                                              </Typography>
                                            </Grid>
                                          </Grid>
                                          <Divider style={{ marginTop: 10, marginBottom: 10 }} />
                                          <Grid container direction="row" style={{ alignItems: 'center', paddingTop: "15px" }}>
                                            <Grid item xs={12} lg={9} display="flex">
                                              {
                                                true ?
                                                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                    <Typography>{t("corporateGoal.label.goalMember")}: {list?.total_member ?? 0}</Typography>
                                                  </Box>
                                                  :
                                                  getMembers(list.id)?.members?.length > 0 ?
                                                    getMembers(list.id)?.members?.map((member, index) => {
                                                      if (index < 10) {
                                                        return (
                                                          <BootstrapTooltip
                                                            placement="top"
                                                            arrow
                                                            title={member?.fullname}
                                                            style={{ marginLeft: '5px' }}
                                                          >
                                                            <Avatar
                                                              src={member?.photo}
                                                              sx={{
                                                                width: 30,
                                                                height: 30,
                                                              }}
                                                            >
                                                            </Avatar>
                                                          </BootstrapTooltip>
                                                        )
                                                      }
                                                      if (getMembers(list.id)?.members?.length - 1 === index) {
                                                        return (<Box sx={{ width: "30px", height: "30px", borderRadius: "50%", background: "#404349", display: "flex", alignItems: "center", justifyContent: "center", ml: 1 }}>
                                                          <Typography color="#fff" fontWeight="400" fontSize="14px">+{getMembers(list.id)?.members?.length - 10}</Typography>
                                                        </Box>)
                                                      }
                                                    })
                                                    : <></>
                                              }
                                            </Grid>
                                            <Grid item xs={12} lg={3} style={{ textAlign: 'right', paddingRight: '5px', color: '#5DA196' }} sx={{ cursor: "pointer" }}>
                                              <Typography onClick={() => handleOpenUpdateGoalProgress(list)}>
                                                <Icon style={{ color: '#5DA196', fontSize: 18, paddingTop: "3px", marginRight: "3px" }}>{'rotate_left'}</Icon>
                                                {t("corporateGoal.label.update")}
                                              </Typography>
                                            </Grid>
                                          </Grid>
                                        </CardContent>
                                      </Card>
                                    </Grid>
                                  )
                                })
                                :
                                <CategoryNoData no={1} category={{ name: item.name, serial: item.id }} goToCreate={gotoCreateGoal} />
                            }
                          </Grid>
                        </Grid>
                      </Grid>)
                  } else {
                    return <></>
                  }
                })
                :
                goalData?.goal_category_list?.length > 0 ?
                  goalData?.goal_category_list?.map((item, key) => {
                    if (valueTab === item.id || valueTab === "all") {
                      return (
                        <>
                          <Grid container lg={12} md={12} key={item.id}>
                            <Grid container item lg={12} md={12}>
                              <Box sx={{ backgroundColor: `${item.color}`, padding: '15px', borderRadius: '5px', margin: '0 auto', width: "100%" }}>
                                <Grid container>
                                  <Grid lg={11} md={12} item sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Icon style={{ color: '#FFFFFF', fontSize: 30 }}>{item.icon}</Icon>
                                    {/* <InternalProcessIcon className={classes.internalIcon} /> */}
                                    <Typography ml={2} fontWeight={600} fontSize={24} style={{ color: "white" }}>
                                      {item.name}
                                    </Typography>
                                  </Grid>
                                  <Grid lg={1} md={12} item xs={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                                    <Box style={{ border: '1px solid white', marginLeft: '40px', borderRadius: '5px', margin: '0 auto' }}>
                                      <Typography fontWeight={600} fontSize={24} style={{ color: "white", textAlign: 'center' }}>
                                        0%
                                      </Typography>
                                    </Box>
                                  </Grid>
                                </Grid>
                              </Box>
                            </Grid>
                            <Grid container direction="row" style={{ justifyContent: 'space-between', marginTop: '20px', marginBottom: '20px' }}>
                              <Grid item lg={11}>
                                <Grid container direction="row">
                                  <Grid item>
                                    <Typography fontSize={14} fontWeight="300" variant="label" >
                                      {item.name} :&nbsp;
                                    </Typography>
                                  </Grid>
                                  <Grid item>
                                    <Typography fontSize={14} fontWeight="300" variant="label" color="primary" >
                                      {item?.goal_list?.length ?? 0}
                                    </Typography>
                                  </Grid>
                                  <Grid item>
                                    <Typography fontSize={14} fontWeight="300" variant="label" >
                                      &nbsp;{t("corporateGoal.label.goalUnit")}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid container direction="row" spacing={2} mb={4}>
                            <CategoryNoData no={2} category={{ name: item.name, serial: item.id }} goToCreate={gotoCreateGoal} />
                          </Grid>
                        </>
                      )
                    }
                  })
                  : <NoData />
              : <NoData />
          }
          <WarningDialog open={isApproveDialogOpen} doConfirm={handleConfirmApprove} setValue={handleConfirmApproveDialog} title="Submit For Approval" text="Are you sure you would like to submit your goal items for approval ?" />
          <ConfirmDialog open={isConfirmDeleteDialogOpen} trash={true} doConfirm={handleConfirmDeleteList} setValue={handleConfirmDeleteDialog} title={t("corporateGoal.label.dialog.deleteTitle")} text={t("corporateGoal.label.dialog.deleteText")} cancel={t("corporateGoal.label.dialog.cancelDelete")} confirm={t("corporateGoal.label.dialog.confirmDelete")} />
          <AlertDialog
            open={isAlertDialogOpen}
            title={title}
            message={message}
            type={typeAlertDialog}
            color={color}
            close={onCloseAlertDialog}
            acceptConfirm=""
            colorHover={colorHover}
            size={size}
          />
          <SimpleDialog open={isSuccessDeleteDialogOpen} setValue={openSuccessDeleteDialog} text={t("corporateGoal.label.dialog.deleteSuccess")} title="Success" subTitle="" />
          <MessageDialog open={openFailedMessageDialog} setValue={handleCloseFailedMessageDialog} type="fail" title="ดำเนินการไม่สำเร็จ" text={errorText + " \nใหม่อีกครั้ง"} />
          <SimpleDialog open={isSuccessUpdateDialogOpen} setValue={openSuccessUpdateDialog} text="Update goal progress successfully." title="Success" subTitle="" />

          {/* update progress dialog */}
          <Dialog onBackdropClick={() => { return false }} open={isUpdateDialogOpen} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="sm" PaperProps={{ sx: { padding: '10px' } }}>
            <DialogContent px={0} pb={0}>
              <Grid container direction="row">
                <Grid item lg={11}>
                  <Typography fontSize={24} fontWeight="600" color="#404349">
                    {t('mygoal.label.updateGoal')}
                  </Typography>
                </Grid>
                <Grid item lg={1} style={{ textAlign: 'right' }}>
                  <Typography color='#404349' style={{ cursor: 'pointer', paddingTop: '8px' }} onClick={handleCloseDialog}>
                    X
                  </Typography>
                </Grid>
              </Grid>
              <Divider sx={{ paddingTop: "20px" }} />
              <Grid container>
                <Grid item lg={4} mt={2}>
                  <Typography fontSize={16} color="#939393">
                    {t('mygoal.label.goalToUpdate')}
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2}>
                  <Typography color="primary">
                    {goalDetail.goal?.name}
                  </Typography>
                </Grid>
                <Grid item lg={4} mt={2}>
                  <Typography fontSize={16} color="#939393">
                    {t('mygoal.label.goalMetric')}
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2}>
                  <Typography color="#404349">
                    {goalDetail.goal_progress?.goal_metric.description}
                  </Typography>
                </Grid>
                <Grid item lg={4} mt={2}>
                  <Typography fontSize={16} color="#939393">
                    {t('mygoal.label.targetValue')}
                  </Typography>
                </Grid>
                <Grid item lg={8} mt={2}>
                  <Typography color="#404349">
                    {Util.upperFirstWord(targetCondition ?? '')} {goalDetail.goal_progress?.target_value} {goalDetail.goal_progress?.unit && goalDetail.goal_progress?.unit !== "-" ? goalDetail.goal_progress?.unit : ""}
                  </Typography>
                </Grid>
                <Grid item lg={4} mt={2} pt={'7px'}>
                  <Typography style={{ fontSize: 16 }} color="#939393">
                    {t('corporateGoal.label.resultAsOf')}:
                  </Typography>
                </Grid>
                <Grid item xs={8} mt={2} color="#404349">
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                      format="dd/MM/yyyy"
                      value={asOfDate}
                      onChange={(newValue) => {
                        if (newValue) {
                          setAsOfDate(Util.formatDate(newValue));
                        } else {
                          setAsOfDate(null)
                        }
                      }}
                      style={{ color: '#404349', fontWeight: !asOfDate ? '300' : '400', fontSize: '16px', borderColor: asOfDate ? '#CED4DA' : '#CC6058' }}
                      inputProps={{
                        placeholder: "As of date", sx: {
                          "&::placeholder": {
                            color: "#AAAAAA"
                          },
                          "&borderColor": {
                            color: '#CED4DA'
                          },
                          "color": '#404349'
                        }
                      }}
                      renderInput={(params) => <TextField {...params}
                        fullWidth
                        size="small"
                        style={{ color: '#404349' }}
                      />}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item lg={4} mt={2} pt={'7px'}>
                  <Typography style={{ fontSize: 16 }} color="#939393">
                    {t('corporateGoal.label.actualValue')}:
                  </Typography>
                </Grid>
                <Grid item xs={8} mt={2} color="#404349">
                  {goalDetail?.goal_progress?.goal_metric?.options?.type === 'date'
                    ?
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <Grid container direction="row">
                        <Grid item lg={10}>
                          <DesktopDatePicker
                            format="dd/MM/yyyy"
                            value={targetValue}
                            onChange={(newValue) => {
                              if (newValue) {
                                setTargetValue(Util.formatDate(newValue));
                              } else {
                                setTargetValue(null)
                              }
                            }}
                            style={{ color: '#404349', fontWeight: !targetValue ? '300' : '400', fontSize: '16px', borderColor: targetValue ? '#CED4DA' : '#CC6058' }}
                            inputProps={{
                              placeholder: "Current Value", sx: {
                                "&::placeholder": {
                                  color: "#AAAAAA"
                                },
                                "&borderColor": {
                                  color: '#CED4DA'
                                },
                                "color": '#404349'
                              }
                            }}
                            renderInput={(params) => <TextField {...params}
                              fullWidth
                              size="small"
                              style={{ color: '#404349' }}
                            />}
                          />
                        </Grid>
                        <Grid item>
                          <IconButton sx={{ display: targetValue ? "" : "none" }} style={{ marginLeft: '10px' }} onClick={handleClearClick}><ClearIcon /></IconButton>
                        </Grid>
                      </Grid>
                    </LocalizationProvider>
                    :
                    (!goalDetail?.goal_progress?.goal_metric?.options)
                      ?
                      <FormControl fullWidth>
                        <Select
                          displayEmpty
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          value={targetValue}
                          onChange={(val) => { setTargetValue(val.target.value) }}
                          renderValue={(selected) => {
                            if (selected === null) {
                              return <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '400', fontSize: '16px' }}>{t("corporateGoal.label.fillTheActualValue")}</Typography>;
                            } else {
                              return <Typography color="#404349">{selected}</Typography>
                            }
                          }}
                          endAdornment={<IconButton sx={{ display: targetValue ? "" : "none" }} style={{ marginRight: '10px' }} onClick={handleClearClick}><ClearIcon /></IconButton>}
                        >
                          <MenuItem disabled value={""}>
                            <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '300', fontSize: '16px' }}>{t("corporateGoal.label.fillTheActualValue")}</Typography>
                          </MenuItem>
                          <MenuItem value={"Success"}>Success</MenuItem>
                          <MenuItem value={"Fail"}>Fail</MenuItem>
                        </Select>
                      </FormControl>
                      :
                      <TextField
                        autoComplete='off'
                        style={{ color: '#A3A3A3', fontSize: '16px' }} id="outlined-basic" value={targetValue} onChange={(e) => setTargetValue(e.target.value.replace(/[^\d.]|\.(?=.*\.)/g, ''))} placeholder={t("corporateGoal.label.fillTheActualValue")} variant="outlined" size="small" fullWidth
                        InputProps={{
                          endAdornment: targetValue ? (
                            <IconButton onClick={handleClearClick}>
                              <ClearIcon />
                            </IconButton>
                          ) : undefined
                        }}
                      />

                  }
                  {
                    (getGoalScale(goalScaleData?.goal?.serial, targetValue, goalScaleData?.goal_progress?.goal_metric?.description)?.valid && targetValue && targetValue !== "") &&
                    <Typography fontSize={14} lineHeight="21px" fontWeight="500" color="#4085C9" textAlign="left" sx={{ textTransform: "uppercase" }}>
                      {t("corporateGoal.label.scaleLevel")} : {getGoalScale(goalScaleData?.goal?.serial, targetValue, goalScaleData?.goal_progress?.goal_metric?.description)?.level}
                    </Typography>
                  }
                </Grid>
                {/* <Grid item lg={2}></Grid> */}
                <Grid item lg={4} mt={2} pt={'7px'}>
                  <Typography style={{ fontSize: 16 }} color="#939393">
                    {t('mygoal.label.goalProgress')}:
                  </Typography>
                </Grid>
                <Grid item xs={8} mt={2}>
                  <FormControl fullWidth>
                    <Select
                      displayEmpty
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      size="small"
                      value={progressValue}
                      onChange={(val) => { setProgressValue(val.target.value) }}
                      sx={{ color: "#404349" }}
                      renderValue={(selected) => {
                        if (selected === null) {
                          return <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '400', fontSize: '16px' }}>Fill the goal progress</Typography>
                        } else {
                          return goalProgressOption?.find((item) => item.serial === selected)?.name
                          // Mockup Because api is not working
                        }
                      }}
                    >
                      <MenuItem disabled value={null}>
                        <Typography style={{ color: '#AAAAAA', WebkitTextFillColor: "initial", fontStyle: 'normal', fontWeight: '300', fontSize: '16px' }}>Fill the goal progress</Typography>
                      </MenuItem>
                      {goalProgressOption?.map((item, key) => {
                        return <MenuItem key={key} value={item.serial} sx={{ color: "#404349" }}>{item.name}</MenuItem>
                      })}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={12} mt={2} pt={'7px'}>
                  <Typography style={{ fontSize: 16 }} color="#939393">
                    {t('corporateGoal.label.remark')}:
                  </Typography>
                </Grid>
                <Grid item lg={12} pt={'7px'}>
                  <TextField
                    autoComplete='off'
                    multiline
                    rows={2}
                    maxRows={4}
                    style={{ color: '#A3A3A3', fontSize: '16px' }} id="outlined-basic" value={remark} onChange={(e) => setRemark(e.target.value)} placeholder={`Fill the remark`} variant="outlined" size="small" fullWidth
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'center' }}>
              <Box classes="mt-3">
                <Button onClick={handleCloseDialog} color="black" variant="outlined" style={{ marginRight: '35px', paddingLeft: '48px', paddingRight: '48px', textTransform: 'none', borderColor: '#DADADA !important' }}>
                  {t('mygoal.label.cancel')}
                </Button>
                <Button onClick={() => updateGoal()} color="primary" variant="contained" style={{ paddingLeft: '48px', paddingRight: '48px', textTransform: 'none' }}>
                  <Typography>
                    {t('mygoal.label.justUpdate')}
                  </Typography>
                </Button>
              </Box>
            </DialogActions>
          </Dialog>
        </Container>
      </Box>
      <DialogAuditLog del={true} close={e => setOpenDialogAuditLog(false)} open={openDialogAuditLog} workloadForm={cycleSelectValue} />

      {goalDetailData?.id && anchorEl &&
        <Menu
          id={'menuoption-' + goalDetailData.id}
          MenuListProps={{
            'aria-labelledby': 'long-button',
          }}
          anchorEl={anchorEl}
          open={openOption}
          onClose={() => setAnchorEl(null)}
          PaperProps={{
            style: {
              maxHeight: 48 * 4.5,
              width: '20ch',
              boxShadow: '0 0 1px 0 rgb(160 160 160 / 31%), 0 2px 6px -3px rgb(160 160 160 / 25%)',
            },
          }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          {options.map((option) => (
            <MenuItem key={option} onClick={() => handleOption(option, goalDetailData)} sx={{ color: "#404349", width: "190px" }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#EFF6F4'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#ffffff'}>
              {
                option === t('corporateGoal.label.goalAlignment') ?
                  <EyeIcon style={{ marginTop: '5px', marginRight: '5px' }} />
                  : option === t('corporateGoal.label.edit') ?
                    <EditIcon style={{ marginTop: '5px', marginRight: '5px' }} className={fullVersion ? {} : classes.inactiveSvg} />
                    : <DeleteIcon style={{ marginTop: '5px', marginRight: '5px' }} className={fullVersion ? {} : classes.inactiveSvg} />
              }
              {/* <Tooltip title={option ?? "-"} placement="top-start"> */}
              <Typography sx={{ width: "70%", textOverflow: "ellipsis", overflow: "hidden" }}>{option}</Typography>
              {/* </Tooltip> */}
            </MenuItem>
          ))}
        </Menu>
      }
    </>
  );
};
export default ManageCorporateGoal;
